export default "__VITE_ASSET__DxRbX7nl__"